import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

// JS Sample Code
const csharp = `var client = new HttpClient();
var request = new HttpRequestMessage(HttpMethod.Post, $"{baseUrl}/API/authentication/login");
var content = new StringContent("{\r\n      \"Email\": \"extuser@ext.com\",\r\n      \"Password\": \"extuserpass\"\r\n}\r\n", null, "application/json");
request.Content = content;
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());
`;

function HTTPCRC() {
  return (
    <Highlight {...defaultProps} theme={theme} code={csharp} language="csharp">
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPCRC;
